import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import FieldInput from './FieldInput'
import styles from './IdCardForm.module.scss'
import Column from '../../models/Column';
import Field from '../../models/Field';

const NEW_FIELD_DEFAULTS = {
  left: 50,
  top: 50,
  width: 125,
  height: 25,
  fontId: undefined,
  fontName: '',
  backgroundId: undefined,
  backgroundName: '',
  color: '#000000',
  spacing: 1,
  align: 'left',
  textSize: 16,
}

export default function FieldsForm({ fields, setFields, template, packageId }) {
  const [availableFields, setAvailableFields] = useState([])

  useEffect(() => {
    Column
      .where({ category: template.category })
      .order({ name: 'asc' })
      .per(100)
      .all()
      .then((res) => {
        const fieldsData = res.data.map((e) => ({ label: e.name, value: e.id }))
        setAvailableFields(fieldsData.filter((field) => !fields[field.value]))
      })
  }, [JSON.stringify(Object.keys(fields))])

  return (
    <div className={`${styles.fieldsForm} ${styles.select}`}>
      <Select
        value=""
        placeholder="Select to add a field"
        options={availableFields}
        onChange={({ label, value }) => {
          const field = new Field({
            x: NEW_FIELD_DEFAULTS.left,
            y: NEW_FIELD_DEFAULTS.top,
            height: label.includes('Image') || label.includes('Picture') || label.includes('Pose') || label.includes('QR') ? 100 : NEW_FIELD_DEFAULTS.height,
            width: label.includes('Image') || label.includes('Picture') || label.includes('Pose') || label.includes('QR') ? 88 : NEW_FIELD_DEFAULTS.width,
            align: NEW_FIELD_DEFAULTS.align,
            spacing: NEW_FIELD_DEFAULTS.spacing,
            color: NEW_FIELD_DEFAULTS.color,
            fontId: label.includes('Barcode') ? 4 : NEW_FIELD_DEFAULTS.fontId,
            backgroundId: NEW_FIELD_DEFAULTS.backgroundId,
            textSize: NEW_FIELD_DEFAULTS.textSize,
            templateId: template.id,
            columnId: value
          })

          field.save().then(() => {
            Field.includes(['column', 'font'])
              .find(field.id)
              .then((res) => {
                setFields({
                  ...fields,
                  [value]: {
                    ...NEW_FIELD_DEFAULTS,
                    label,
                    id: value,
                    object: res.data,
                    fontName: label.includes('Barcode') ? 'Barcode' : ''
                  },
                })
              })
          }).catch((e) => {
            console.log(e)
          })
        }}
      />
      {Object.values(fields).map((field) => (
        <FieldInput key={field.id} field={field} fields={fields} setFields={setFields} template={template} packageId={packageId} />
      ))}
    </div>
  )
}
